import React, {Component} from 'react';
import './App.scss';
import ProjectDatabase from "./helper/ProjectDatabase";
import * as Constants from './helper/Constants';
import Slider from "react-slick";
import {Link} from "react-router-dom";
import ImageTransformer from "./helper/ImageTransformer";

class Startpage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentImageDescription: "",
            toggle: false,
            images: []
        }

        this.sliderSettings = {
            dots: true,
            infinite: true,
            speed: 500,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
            pauseOnHover: false,
            arrows: false,
            beforeChange: (oldIndex, newIndex) => {this.handleSlideChange(newIndex)}
        };

    }

    componentDidMount() {
        (async () => {
            let images = [];
            try {
                let startPageProjects = await ProjectDatabase.getStartPageProjects();
                let picturesResponse = await ProjectDatabase.getAllStartPictures();
                for (let project of startPageProjects.data) {
                    images.push({
                        original: picturesResponse.data.filter(p => p.project_id === project.id)[0].s3_url,
                        beschreibung: project.titel,
                        projectUrlId: project.url_id
                    })
                }
                if (images.length > 0) {
                    this.setState({images: images, currentImageDescription: images[0].beschreibung})
                }
            } catch (e) {
                console.log(e);
            }

        })()

    }

    handleSlideChange(index) {
        if (this.state.images.length > 0) {
            this.setState(state => ({currentImageDescription: this.state.images[index].beschreibung, toggle: !state.toggle}));
        }
    }

    render() {
        return (
            <div className="main-body fadeIn-1s">
                <div className="image-collection fullwidth-on-mobile">
                    <Slider {...this.sliderSettings}>
                        {this.state.images.map(image => (
                            <div className={"slider-image-container"} key={image.original}>
                                <Link to={`${Constants.LINK_HOME}/project/${image.projectUrlId}`}>
                                    <img src={ImageTransformer.transform(image.original, 2000)} alt={image.beschreibung}/>
                                </Link>
                            </div>
                        ))}
                    </Slider>
                    <div id="startpage-image-gallery-description">
                        {this.state.toggle && (
                            <div className="fadeIn">{this.state.currentImageDescription}</div>
                        )}
                        {!this.state.toggle && (
                            <div className="fadeIn">{this.state.currentImageDescription}</div>
                        )}
                    </div>

                </div>
            </div>
        );
    }
}

export default Startpage;
